'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = exports.fetchOptions = undefined;

var _methods = require('./methods');

Object.keys(_methods).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _methods[key];
    }
  });
});

var _auth = require('./auth');

Object.keys(_auth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _auth[key];
    }
  });
});

var _fetchOptions2 = require('./fetchOptions');

var _fetchOptions3 = _interopRequireDefault(_fetchOptions2);

var _now2 = require('./now');

var _now3 = _interopRequireDefault(_now2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.fetchOptions = _fetchOptions3.default;
exports.now = _now3.default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/codev-api/index.js
// module id = 1076
// module chunks = 0